// AlertBanner primitive — port of design/v3/Primitives.jsx:122-142.
// tones: danger | warning | info. icon circle + message + optional CTA link.

import type { CSSProperties } from 'react';

export type AlertTone = 'danger' | 'warning' | 'info';

const toneStyle: Record<
  AlertTone,
  { bg: string; border: string; icon: string }
> = {
  danger: {
    bg: 'var(--danger-bg)',
    border: 'var(--danger)',
    icon: 'var(--danger)',
  },
  warning: {
    bg: 'var(--warning-bg)',
    border: 'var(--warning)',
    icon: 'var(--warning)',
  },
  info: {
    bg: 'var(--info-bg)',
    border: 'var(--info)',
    icon: 'var(--info)',
  },
};

export interface AlertBannerProps {
  tone?: AlertTone;
  message: string;
  cta?: string;
  onCta?: () => void;
  style?: CSSProperties;
}

export function AlertBanner({
  tone = 'danger',
  message,
  cta,
  onCta,
  style,
}: AlertBannerProps) {
  const s = toneStyle[tone];
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 16px',
        borderRadius: 10,
        background: s.bg,
        border: `1px solid ${s.border}`,
        fontSize: 14,
        color: 'var(--fg-1)',
        ...style,
      }}
    >
      <span
        aria-hidden
        style={{
          width: 20,
          height: 20,
          borderRadius: 'var(--radius-full)',
          background: s.icon,
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          fontSize: 12,
          flexShrink: 0,
        }}
      >
        !
      </span>
      <span style={{ flex: 1 }}>{message}</span>
      {cta && (
        <button
          type="button"
          onClick={onCta}
          style={{
            color: s.icon,
            fontWeight: 500,
            fontSize: 13,
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'var(--font-sans)',
          }}
        >
          {cta}
        </button>
      )}
    </div>
  );
}
